// Helper for mapping legacy section "store keys" to new section keys
// Currently needed because /form data does not include section keys

// Only using SF86 because it's a superset of all form sections
import { FLAT_SF86 } from 'config/formTypes';
import * as Sections from 'constants/sections';

const sectionKeyMap = {};

FLAT_SF86.filter((s) => s.storeKey && s.parentStore).forEach((s) => {
  sectionKeyMap[`${s.parentStore}.${s.storeKey}`] = s.key;
});

// special case
sectionKeyMap['Foreign.Passport'] = Sections.CITIZENSHIP_US_PASSPORT;
sectionKeyMap['Package.Comments'] = Sections.REVIEW_AND_SUBMIT_COMMENTS;
sectionKeyMap['Substance.IllegalControlledSubstanceUse'] = Sections.SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE;
sectionKeyMap['Substance.EmployedIllegalControlledSubstanceUse'] = Sections.SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE;
sectionKeyMap['Substance.AlcoholCounselings'] = Sections.SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL;

// Additional subsections for PVQ
sectionKeyMap['Legal.ForeignInvestigation'] = Sections.LEGAL_INVESTIGATIONS_FOREIGN;
sectionKeyMap['Legal.ClearanceIssues'] = Sections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES;
sectionKeyMap['Legal.PivIssues'] = Sections.LEGAL_INVESTIGATIONS_PIV_ISSUES;
sectionKeyMap['Legal.ProtectedUnauthorized'] = Sections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED;
sectionKeyMap['Legal.NonCompliance'] = Sections.LEGAL_TECHNOLOGY_NONCOMPLIANCE;
sectionKeyMap['Legal.CriminalConvictions'] = Sections.LEGAL_CRIMINAL_CONVICTIONS;

sectionKeyMap['Foreign.Future'] = Sections.FOREIGN_ACTIVITIES_FUTURE;
sectionKeyMap['Foreign.Current'] = Sections.FOREIGN_ACTIVITIES_CURRENT;
sectionKeyMap['Foreign.OnGoingSupport'] = Sections.FOREIGN_ACTIVITIES_ONGOINGSUPPORT;

sectionKeyMap['Legal.Denied'] = Sections.LEGAL_TECHNOLOGY_DENIED;

sectionKeyMap['Legal.TerroristOrganizationMembership'] = Sections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP;
sectionKeyMap['Legal.TerrorismEngagement'] = Sections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT;
sectionKeyMap['Legal.TerrorismAdvocacy'] = Sections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY;
sectionKeyMap['Legal.RightsSuppressionGroup'] = Sections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP;
sectionKeyMap['Legal.ViolentRightsSuppressionGroup'] = Sections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP;
sectionKeyMap['Legal.ViolentOrganization'] = Sections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION;
sectionKeyMap['Legal.ViolentActs'] = Sections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS;
sectionKeyMap['Legal.HateCrimeAdvocacy'] = Sections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY;
sectionKeyMap['Legal.InternationalAndDomesticTerrorism'] = Sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM;
sectionKeyMap['Legal.InternationalAndDomesticTerrorismEngagement'] = Sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT;
sectionKeyMap['Legal.InternationalAndDomesticTerrorismAssociation'] = Sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION;
sectionKeyMap['Legal.InternationalAndDomesticTerrorismAdvocacy'] = Sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY;

sectionKeyMap['Financial.FederalDebt'] = Sections.FINANCIAL_FEDERAL_DEBT;
sectionKeyMap['Financial.AssetSeized'] = Sections.FINANCIAL_ASSET_SEIZED;
sectionKeyMap['Financial.Alimony'] = Sections.FINANCIAL_ALIMONY;
sectionKeyMap['Financial.Eviction'] = Sections.FINANCIAL_EVICTION;
sectionKeyMap['Financial.Foreclosure'] = Sections.FINANCIAL_FORECLOSURE;
sectionKeyMap['Financial.Repossession'] = Sections.FINANCIAL_REPOSSESSION;
sectionKeyMap['Financial.ChildSupport'] = Sections.FINANCIAL_CHILD_SUPPORT;
sectionKeyMap['Financial.CivilJudgement'] = Sections.FINANCIAL_CIVIL_JUDGEMENT;
sectionKeyMap['Financial.Lien'] = Sections.FINANCIAL_LIEN;
sectionKeyMap['Financial.NonpaymentNonfederal'] = Sections.FINANCIAL_NONPAYMENT_NONFEDERAL;

sectionKeyMap['Substance.ThcClearanceUses'] = Sections.SUBSTANCE_USE_THC_CLEARANCE;
sectionKeyMap['Substance.ThcPublicSafetyUses'] = Sections.SUBSTANCE_USE_THC_PUBLIC_SAFETY;
sectionKeyMap['Substance.ThcInvolvements'] = Sections.SUBSTANCE_USE_THC_PURCHASE;
sectionKeyMap['Substance.ThcUses'] = Sections.SUBSTANCE_USE_THC_USAGE;
sectionKeyMap['Substance.DrugNegativeImpact'] = Sections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT;

export default sectionKeyMap;
